/* Andaz theme — interactions. No external libraries. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const cfg = window.AndazConfig || {};
  const money = (cents) => {
    const n = Number(cents) / 100;
    const whole = Math.round(n) === n;
    const grp = (x, d, t, c) => { const [i, f] = x.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f && !whole ? c + f : ''); };
    const fmt = cfg.moneyFormat || ((cfg.currencyPrefix || 'Rs ') + '{{amount}}');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      return grp(n, 2, ',', '.');
    });
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- toast ---------- */
  let tt;
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(tt); tt = setTimeout(() => (t.hidden = true), 2800);
  }
  window.AndazToast = toast;

  /* ---------- drawers ---------- */
  const scrim = $('#scrim');
  function closeAll() { $$('.drawer').forEach((d) => (d.hidden = true)); if (scrim) scrim.hidden = true; }
  function open(id) { closeAll(); const d = $(id); if (d) { d.hidden = false; scrim.hidden = false; } }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  scrim && scrim.addEventListener('click', closeAll);
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-menu]')) { e.preventDefault(); open('#menu-drawer'); }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-open-size]')) { e.preventDefault(); open('#size-drawer'); }
    if (e.target.closest('[data-open-wishlist]')) { e.preventDefault(); open('#wishlist-drawer'); renderWish(); }
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); open('#search-overlay'); const q = $('[data-search-input]'); if (q) setTimeout(() => q.focus(), 30); }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeAll(); }
  });

  /* ---------- cart (Shopify AJAX API) ---------- */
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  async function getCart() { const r = await fetch(root + 'cart.js'); return r.json(); }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach((b) => { b.textContent = cart.item_count; b.hidden = !cart.item_count; });
    const lines = $('#cart-lines'); if (!lines) return;
    const free = (cfg.freeShipping || 0) * 100;
    const meter = $('#cart-meter');
    if (meter) {
      // free delivery only counts Andaz by Uneza Fazeel items (separate shipping profile)
      const vendor = cfg.freeShippingVendor;
      const own = cart.items.filter((it) => !vendor || it.vendor === vendor).reduce((s, it) => s + it.final_line_price, 0);
      if (!free || !own) meter.innerHTML = '';
      else {
        const left = free - own;
        meter.innerHTML = (left <= 0 ? `Your <b>${esc(vendor)}</b> items get <b>free delivery</b>` : `Add <b>${money(left)}</b> more of ${esc(vendor)} for free delivery`) +
          `<div class="bar"><i style="width:${Math.min(100, (own / free) * 100)}%"></i></div>`;
      }
    }
    lines.innerHTML = cart.items.length ? cart.items.map((it) => `
      <div class="line">
        ${it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=160" alt="" width="64" height="85" loading="lazy">` : '<span></span>'}
        <div><a href="${it.url}">${esc(it.product_title)}</a>
          ${it.variant_title ? `<small>${esc(it.variant_title)}</small>` : ''}
          <div><span class="q"><button data-qty="${it.key}" data-n="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button data-qty="${it.key}" data-n="${it.quantity + 1}" aria-label="Increase">+</button></span>
          <button class="rm" data-qty="${it.key}" data-n="0">Remove</button></div></div>
        <b style="font-weight:500;font-variant-numeric:tabular-nums">${money(it.final_line_price)}</b>
      </div>`).join('') : `<div class="empty"><p>Your bag is empty.</p><a class="btn" href="${root}collections/all" data-close>Continue shopping</a></div>`;
    const foot = $('#cart-foot'); if (foot) foot.hidden = !cart.item_count;
    const sub = $('#cart-subtotal'); if (sub) sub.textContent = money(cart.total_price);
  }
  async function openCart() { try { renderCart(await getCart()); } catch (e) {} open('#cart-drawer'); }
  async function addToCart(id, qty = 1, btn) {
    if (btn) btn.disabled = true;
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) }] }) });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || 'Could not add this item'); return; }
      if (cfg.cartType === 'page') { location.href = root + 'cart'; return; }
      await openCart();
    } catch (e) { toast('Could not add this item. Please try again.'); }
    finally { if (btn) btn.disabled = false; }
  }
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: q.dataset.qty, quantity: Number(q.dataset.n) }) });
      renderCart(await r.json());
      return;
    }
    const a = e.target.closest('[data-quick-add]');
    if (a) { e.preventDefault(); e.stopPropagation(); addToCart(a.dataset.quickAdd, 1, a); }
  });
  getCart().then(renderCart).catch(() => {});

  /* ---------- tabs (product tabs section) ---------- */
  $$('[data-tabs]').forEach((wrap) => {
    const btns = $$('[role=tab]', wrap), panels = $$('[role=tabpanel]', wrap);
    btns.forEach((b, i) => b.addEventListener('click', () => {
      btns.forEach((x, j) => x.setAttribute('aria-selected', i === j));
      panels.forEach((p, j) => (p.hidden = i !== j));
    }));
  });

  /* ---------- colour swatches from colour names ---------- */
  const CW = [['navy','#1d2c63'],['royal blue','#2849a8'],['sky','#8dbbe0'],['ice blue','#cfe3f2'],['turquoise','#2aa5a8'],['aqua','#5cc7c4'],['blue','#3e6db5'],['emerald','#0f5b3d'],['bottle','#14432e'],['mint','#b5d8c0'],['sage','#a9c1a2'],['pistachio','#c5dca0'],['olive','#6b6a34'],['green','#3d7a4f'],['plum','#5b1f45'],['mulberry','#6e1d48'],['magenta','#b0207a'],['lilac','#c3a8d6'],['lavender','#b9a6dc'],['purple','#6a3b8c'],['ruby','#9b1131'],['maroon','#6b1424'],['crimson','#a8142c'],['red','#b3261e'],['rust','#a8471c'],['coral','#ef7c6b'],['peach','#f2b89a'],['pink','#eaa3b7'],['blush','#f0c4c9'],['mustard','#c99a1e'],['gold','#c9a24a'],['beige','#dccbad'],['skin','#e5c9a8'],['camel','#b98d5c'],['mocha','#8a6a55'],['brown','#6a4632'],['chocolate','#4a2c20'],['grey','#9a979c'],['gray','#9a979c'],['charcoal','#3a3a3e'],['black','#17141a'],['off-white','#f3eee4'],['ivory','#f4efe2'],['cream','#f1e8d2'],['white','#fbfaf7']];
  const sw = (c) => { const l = c.toLowerCase(); const m = CW.find(([k]) => l.includes(k)); return m ? m[1] : null; };
  $$('[data-swatch]').forEach((i) => { const c = sw(i.dataset.swatch); if (c) i.style.background = c; });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach((pdp) => {
    const data = JSON.parse($('script[data-product-json]', pdp).textContent);
    const idInput = $('input[name="id"]', pdp);
    const priceEl = $('[data-price]', pdp), stockEl = $('[data-stock]', pdp);
    const atcs = $$('[data-atc]', document);
    const chosen = $$('[data-option-index]', pdp).map((g) => { const b = $('[aria-pressed="true"]', g); return b ? b.dataset.value : null; });

    function current() { if (data.variants.length === 1) return data.variants[0]; return data.variants.find((v) => v.options.every((o, i) => o === chosen[i])); }
    function update() {
      $$('[data-option-index]', pdp).forEach((g) => {
        const idx = Number(g.dataset.optionIndex);
        const lbl = $(`[data-chosen="${idx}"]`, pdp); if (lbl) lbl.textContent = chosen[idx] || '';
        $$('button', g).forEach((b) => {
          b.setAttribute('aria-pressed', b.dataset.value === chosen[idx]);
          const test = chosen.slice(); test[idx] = b.dataset.value;
          const ok = data.variants.some((x) => x.available && x.options.every((o, i) => test[i] == null || o === test[i]));
          b.classList.toggle('na', !ok);
        });
      });
      const v = current();
      const ready = chosen.every(Boolean);
      if (v && 'comingSoon' in pdp.dataset) {
        idInput && (idInput.value = v.id);
        if (v.featured_media) showMedia(v.featured_media.id);
      } else if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s><span class="off">Save ${Math.round((1 - v.price / v.compare_at_price) * 100)}%</span>` : '');
        $$('[data-sticky-price]').forEach((e) => (e.textContent = money(v.price)));
        if (stockEl) { const pre = (stockEl.dataset.preIds || '').includes(`,${v.id},`); stockEl.textContent = v.available ? (pre ? stockEl.dataset.pre : stockEl.dataset.in) : stockEl.dataset.out; stockEl.classList.toggle('out', !v.available); }
        atcs.forEach((b) => { b.disabled = !v.available; b.textContent = v.available ? b.dataset.label : b.dataset.soldout; });
        if (v.featured_media) showMedia(v.featured_media.id);
        if (ready && data.variants.length > 1 && !(window.Shopify && Shopify.designMode)) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
      } else if (ready) {
        atcs.forEach((b) => { b.disabled = true; b.textContent = b.dataset.unavailable; });
      }
      const wa = $('[data-wa]', pdp);
      if (wa) { const t = `${wa.dataset.text}${v && data.variants.length > 1 ? ' — ' + v.title : ''} — ${location.origin}${data.url}`; wa.href = `https://wa.me/${wa.dataset.number}?text=${encodeURIComponent(t)}`; }
    }
    pdp.addEventListener('click', (e) => {
      const b = e.target.closest('[data-option-index] button');
      if (b) { chosen[Number(b.closest('[data-option-index]').dataset.optionIndex)] = b.dataset.value; update(); return; }
      const t = e.target.closest('[data-media-id]');
      if (t) showMedia(Number(t.dataset.mediaId));
      const s = e.target.closest('[data-step]');
      if (s) { const q = $('[name="quantity"]', pdp); q.value = Math.max(1, Number(q.value) + Number(s.dataset.step)); }
    });
    function showMedia(id) {
      const t = $(`[data-media-id="${id}"]`, pdp); if (!t) return;
      $$('[data-media-id]', pdp).forEach((x) => x.setAttribute('aria-current', x === t));
      const main = $('.mainimg img', pdp);
      if (main && t.dataset.full) { main.src = t.dataset.full; main.srcset = ''; main.alt = t.dataset.alt || ''; }
    }
    function submit(e) {
      e && e.preventDefault();
      if (!chosen.every(Boolean)) { toast('Please choose ' + data.options.filter((o, i) => !chosen[i]).join(' and ').toLowerCase()); $('[data-option-index]', pdp).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      const v = current(); if (!v || !v.available) return;
      addToCart(v.id, $('[name="quantity"]', pdp).value, e && e.submitter);
    }
    const pform = $('form.product-form', pdp); if (pform) pform.addEventListener('submit', submit);
    $$('[data-atc-sticky]').forEach((b) => b.addEventListener('click', () => submit()));
    update();
  });

  /* ---------- collection filters: submit on change ---------- */
  $$('form[data-filters]').forEach((f) => {
    f.addEventListener('change', (e) => { if (e.target.matches('input[type=checkbox],select')) f.submit(); });
  });
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u;
  }));

  /* ---------- reels: play only while visible ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((ents) => ents.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'metadata'; v.play().catch(() => {}); } else v.pause();
    }), { threshold: 0.5 });
    $$('video.reel-video').forEach((v) => io.observe(v));
  }


  /* ---------- New In slider ---------- */
  $$('[data-slider]').forEach((s) => {
    const track = $('[data-track]', s), slides = $$('[data-slide], .hs-slide', s), dots = $$('[data-dots] button', s);
    if (slides.length < 2) return;
    let i = 0, timer;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ms = (Number(s.dataset.interval) || 6) * 1000;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, j) => d.setAttribute('aria-current', j === i));
      slides.forEach((sl, j) => { sl.setAttribute('aria-hidden', j !== i); sl.inert = j !== i; });
    };
    const restart = () => { clearInterval(timer); if (!reduce) timer = setInterval(() => go(i + 1), ms); };
    $('[data-prev]', s).addEventListener('click', () => { go(i - 1); restart(); });
    $('[data-next]', s).addEventListener('click', () => { go(i + 1); restart(); });
    dots.forEach((d, j) => d.addEventListener('click', () => { go(j); restart(); }));
    s.addEventListener('mouseenter', () => clearInterval(timer));
    s.addEventListener('mouseleave', restart);
    let x0 = null;
    s.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
    s.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); restart(); } x0 = null; });
    go(0); restart();
  });


  /* ---------- wishlist (saved in this browser, no app needed) ---------- */
  const WKEY = 'andaz-wishlist';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } };
  const writeWish = (l) => { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {} };
  function syncWish() {
    const l = readWish(), set = new Set(l.map((x) => x.h));
    $$('[data-wish-count]').forEach((b) => { b.textContent = l.length; b.hidden = !l.length; });
    $$('[data-wish]').forEach((b) => {
      const on = set.has(b.dataset.wish); b.setAttribute('aria-pressed', on);
      const t = $('[data-wish-label]', b); if (t) t.textContent = on ? 'Saved to wishlist' : 'Save to wishlist';
    });
  }
  function renderWish() {
    const box = $('#wishlist-items'); if (!box) return;
    const l = readWish();
    box.innerHTML = l.length ? l.map((x) => `
      <div class="wl-item">
        <a href="${x.u}">${x.i ? `<img src="${x.i}" alt="" width="72" height="96" loading="lazy">` : ''}</a>
        <div><small>${esc(x.v)}</small><a href="${x.u}">${esc(x.t)}</a><div style="font-weight:500;margin-top:2px">${esc(x.p)}</div>
          <div class="acts"><a href="${x.u}">View</a><button type="button" data-unwish="${esc(x.h)}">Remove</button></div></div>
      </div>`).join('') : `<div class="empty"><p>Nothing saved yet.<br>Tap the heart on any product to save it here.</p></div>`;
  }
  document.addEventListener('click', (e) => {
    const w = e.target.closest('[data-wish]');
    if (w) {
      e.preventDefault(); e.stopPropagation();
      let l = readWish(); const h = w.dataset.wish;
      if (l.some((x) => x.h === h)) { l = l.filter((x) => x.h !== h); toast('Removed from your wishlist'); }
      else { l.unshift({ h, t: w.dataset.wishTitle, v: w.dataset.wishVendor, i: w.dataset.wishImg, p: w.dataset.wishPrice, u: w.dataset.wishUrl }); toast('Saved to your wishlist'); }
      writeWish(l); syncWish(); renderWish(); return;
    }
    const u = e.target.closest('[data-unwish]');
    if (u) { writeWish(readWish().filter((x) => x.h !== u.dataset.unwish)); syncWish(); renderWish(); }
  }, true);
  syncWish();
  if (location.hash === '#wishlist') { open('#wishlist-drawer'); renderWish(); }

  /* ---------- search pop-up with live results (Shopify predictive search) ---------- */
  const sIn = $('[data-search-input]'), sOut = $('[data-search-results]');
  let sTimer;
  async function liveSearch(q) {
    if (!sOut) return;
    if (!q) { sOut.innerHTML = ''; return; }
    try {
      const r = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`);
      const d = await r.json(); const ps = (d.resources && d.resources.results && d.resources.results.products) || [];
      sOut.innerHTML = ps.length ? ps.map((p) => `
        <div class="card"><a class="ph" href="${p.url}">${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=500" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
        <div class="meta"><div class="ven">${esc(p.vendor || '')}</div><a class="t" href="${p.url}">${esc(p.title)}</a><div class="price">${(p.tags || []).includes('Coming Soon') ? '<span class="soon">Coming Soon</span>' : money(Math.round(parseFloat(p.price) * 100))}</div></div></div>`).join('') +
        `<div class="more"><a class="btn" href="${root}search?type=product&q=${encodeURIComponent(q)}">See all results</a></div>`
        : `<p style="color:var(--muted)">No results for “${esc(q)}”. Try karandi, chiffon or velvet.</p>`;
    } catch (e) { sOut.innerHTML = ''; }
  }
  if (sIn) sIn.addEventListener('input', () => { clearTimeout(sTimer); sTimer = setTimeout(() => liveSearch(sIn.value.trim()), 250); });
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-pop]'); if (b && sIn) { sIn.value = b.dataset.pop; liveSearch(b.dataset.pop); } });

  /* ---------- copy buttons (contact page) ---------- */
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-copy]'); if (!c) return;
    const v = c.dataset.copy;
    try { navigator.clipboard.writeText(v).then(() => toast('Copied ' + v), () => toast(v)); } catch (err) { toast(v); }
  });

  /* ---------- track order page: send details on WhatsApp ---------- */
  $$('form[data-track]').forEach((f) => f.addEventListener('submit', (e) => {
    e.preventDefault();
    const o = f.querySelector('[name=order]').value.trim(), ph = f.querySelector('[name=phone]').value.trim();
    const t = `Assalam o Alaikum, please share the status of my order ${o}. Phone: ${ph}`;
    window.open(`https://wa.me/${f.dataset.track}?text=${encodeURIComponent(t)}`, '_blank', 'noopener');
  }));


  /* ---------- related products (loaded after the page) ---------- */
  $$('[data-recs]').forEach((el) => {
    if (el.children.length || !el.dataset.url) return;
    fetch(el.dataset.url).then((r) => r.text()).then((html) => {
      const d = document.createElement('div'); d.innerHTML = html;
      const fresh = d.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        $$('[data-swatch]', el).forEach((i) => { const c = sw(i.dataset.swatch); if (c) i.style.background = c; });
        syncWish();
      }
    }).catch(() => {});
  });


  /* ---------- collection: Load more ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-load-more]');
    if (!b) return;
    e.preventDefault();
    b.setAttribute('aria-busy', 'true'); b.textContent = 'Loading…';
    try {
      const html = await (await fetch(b.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-collection-grid]'), more = $('[data-collection-grid]', doc);
      if (grid && more) {
        [...more.children].forEach((c) => grid.appendChild(c));
        $$('[data-swatch]', grid).forEach((i) => { const c = sw(i.dataset.swatch); if (c) i.style.background = c; });
        syncWish();
      }
      const nb = $('[data-load-more]', doc);
      const shown = grid ? grid.children.length : 0, total = Number(b.dataset.total) || shown;
      const s = $('[data-shown]'); if (s) s.textContent = Math.min(shown, total);
      const bar = $('[data-bar]'); if (bar) bar.style.width = Math.min(100, (shown / total) * 100) + '%';
      const pages = $('[data-pages]'), np = $('[data-pages]', doc); if (pages && np) pages.innerHTML = np.innerHTML;
      if (nb) { b.href = nb.href; b.removeAttribute('aria-busy'); b.textContent = 'Load more'; }
      else b.remove();
    } catch (err) { location.href = b.href; }
  });


  /* ---------- mobile: show the bottom Add-to-bag bar only when the main button is off screen ---------- */
  const stickyBar = $('.sticky-atc'), mainAtc = $('.product-form [data-atc]');
  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      const below = en.boundingClientRect.top > window.innerHeight;
      stickyBar.classList.toggle('show', !en.isIntersecting && !below);
    }).observe(mainAtc);
  } else if (stickyBar) stickyBar.classList.add('show');

  /* ---------- brands page: each brand card cycles through its product photos ---------- */
  $$('[data-brand-rotate]').forEach((list) => {
    const ms = (Number(list.dataset.brandRotate) || 5) * 1000;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $$('[data-brand-card]', list).forEach((card, ci) => {
      const imgs = $$('img.bslide', card);
      if (imgs.length < 2) return;
      let i = 0;
      setTimeout(() => setInterval(() => {
        if (document.hidden) return;
        imgs[i].classList.remove('on'); i = (i + 1) % imgs.length; imgs[i].classList.add('on');
      }, ms), (ci % 4) * 600);
    });
  });

  /* ---------- newsletter / contact success messages ---------- */
  if (location.search.includes('customer_posted=true')) toast('Thank you for subscribing.');
})();

/* ---------- offer popup (sections/offer-popup.liquid) ---------- */
(function () {
  var pop = document.getElementById('offer-pop');
  if (!pop) return;
  var key = 'andaz-offer-' + (pop.dataset.key || '1');
  var skip = pop.dataset.skip;
  try { if (sessionStorage.getItem(key)) return; } catch (e) {}
  if (skip && location.pathname.indexOf(skip) === 0) return;
  function close() {
    pop.hidden = true;
    document.documentElement.style.overflow = '';
    try { sessionStorage.setItem(key, '1'); } catch (e) {}
  }
  pop.querySelectorAll('[data-offer-close]').forEach(function (b) { b.addEventListener('click', close); });
  pop.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { try { sessionStorage.setItem(key, '1'); } catch (e) {} }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
  setTimeout(function () {
    pop.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }, (parseInt(pop.dataset.delay, 10) || 0) * 1000);
})();
